module.exports = __webpack_public_path__ + "img/93589fe.jpg";